import React, { useState } from 'react';
import { NavMenuShop } from '../../navMenu/NavMenuShop';
import { Input, Label } from 'reactstrap';

export function MailConfig() {
    document.title = 'E-Mail setup | Anna Shepeta';

    return (
        <div className="mail-config">
            <NavMenuShop />
             <div className="container my-5">
               <header className="text-center mb-5">
                 <h1 className="display-6">Newsletters E-mail configuration</h1>
               </header>
               <i>Configured in appsettings.json</i>
             </div>
        </div>
    );
}